import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
    Home,
    Receipt,
    Building,
    Users,
    User,
    LogOut,
    Calculator,
} from "lucide-react";

function Navbar() {
    const { user, logout } = useAuth();
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path ? "nav-link active" : "nav-link";
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-brand">
                    <Building className="navbar-icon" />
                    <span>Control de Gastos</span>
                </div>

                <div className="navbar-nav">
                    <Link to="/" className={isActive("/")}>
                        <Home size={18} />
                        <span>Dashboard</span>
                    </Link>

                    <Link to="/gastos" className={isActive("/gastos")}>
                        <Receipt size={18} />
                        <span>Gastos</span>
                    </Link>

                    <Link
                        to="/habitaciones"
                        className={isActive("/habitaciones")}
                    >
                        <Building size={18} />
                        <span>Habitaciones</span>
                    </Link>

                    {user?.tipo_usuario === "gestor" && (
                        <>
                            <Link to="/usuarios" className={isActive("/usuarios")}>
                                <Users size={18} />
                                <span>Usuarios</span>
                            </Link>

                            <Link
                                to="/renta-anual"
                                className={isActive("/renta-anual")}
                            >
                                <Calculator size={18} />
                                <span>Renta</span>
                            </Link>
                        </>
                    )}
                </div>

                <div className="navbar-user">
                    <div className="user-info">
                        <span className="user-name">{user?.nombre}</span>
                        <span className="user-role">
                            {user?.tipo_usuario === "gestor"
                                ? "Gestor"
                                : "Inquilino"}
                        </span>
                    </div>

                    <Link to="/perfil" className={isActive("/perfil")}>
                        <User size={18} />
                    </Link>

                    <button onClick={logout} className="btn-logout">
                        <LogOut size={18} />
                    </button>
                </div>
            </div>

            <style jsx>{`
                .navbar {
                    background: white;
                    border-bottom: 1px solid #e5e7eb;
                    padding: 0 20px;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                }

                .navbar-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 64px;
                }

                .navbar-brand {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-weight: 600;
                    font-size: 18px;
                    color: #1f2937;
                }

                .navbar-icon {
                    color: #3b82f6;
                }

                .navbar-nav {
                    display: flex;
                    gap: 8px;
                }

                .nav-link {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 8px 12px;
                    border-radius: 6px;
                    color: #6b7280;
                    text-decoration: none;
                    font-weight: 500;
                    transition: all 0.2s;
                }

                .nav-link:hover {
                    background-color: #f3f4f6;
                    color: #374151;
                }

                .nav-link.active {
                    background-color: #dbeafe;
                    color: #1d4ed8;
                }

                .navbar-user {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }

                .user-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                }

                .user-name {
                    font-weight: 500;
                    color: #1f2937;
                    font-size: 14px;
                }

                .user-role {
                    font-size: 12px;
                    color: #6b7280;
                }

                .btn-logout {
                    display: flex;
                    align-items: center;
                    padding: 8px;
                    border: none;
                    background: none;
                    color: #6b7280;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.2s;
                }

                .btn-logout:hover {
                    background-color: #fef2f2;
                    color: #dc2626;
                }

                @media (max-width: 768px) {
                    .navbar {
                        padding: 0 10px;
                    }

                    .navbar-nav span {
                        display: none;
                    }

                    .user-info {
                        display: none;
                    }

                    .navbar-nav {
                        gap: 4px;
                    }

                    .nav-link {
                        padding: 8px;
                    }
                }
            `}</style>
        </nav>
    );
}

export default Navbar;
